import { loanTypes } from '~/constants/loanTypes';

export const simpleKronerVisible = (type) => {
  return (type === loanTypes.simple);
};

export const topUpOhcVisible = (type) => {
  return (type === loanTypes.topup);
};

export const immediateVisible = (type) => {
  return (type === loanTypes.immediate);
};

export const refillVisible = (type) => {
  return (type === loanTypes.refill);
};
